import { useEffect } from "react";

/**
 * Sets `document.title` and the `<meta name="description">` content for
 * the page that calls it. SPA-only: on unmount nothing is restored — the
 * next page mounted sets its own title/description.
 *
 * No dependency array on purpose: this re-runs on every render so a page
 * whose title depends on async data (e.g. JobDetail, which shows a brand
 * title while loading and the job title once it arrives) stays in sync
 * without having to list its own deps here.
 */
export function useDocumentMeta(title: string, description?: string): void {
  useEffect(() => {
    document.title = title;

    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
  });
}

export default useDocumentMeta;
